<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- Logo & System Name -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <v-img
            :src="require('@/assets/images/logos/logo.png')"
            max-height="30px"
            max-width="30px"
            alt="logo"
            contain
            class="me-3"
          ></v-img>

          <h2 class="text-2xl font-weight-semibold">
            {{ systemName }}
          </h2>
        </v-card-title>

        <!-- Title -->
        <h2 class="mb-4 text-xl font-bold text-center">Reset Password</h2>

        <!-- Form -->
        <v-card-text>
          <form class="p-5 bg-white border rounded shadow" @submit.prevent="resetPassword">
            <v-text-field
              type="password"
              outlined
              label="Password"
              name="password"
              v-model="password"
              placeholder="Enter new password"
              class="mb-4"
            />

            <v-text-field
              type="password"
              outlined
              label="Confirm Password"
              name="passwordConfirm"
              v-model="passwordConfirm"
              placeholder="Re-enter password"
              class="mb-4"
            />

            <v-btn
              block
              color="primary"
              class="mt-6"
              type="submit"
            >
              Reset Password
            </v-btn>
          </form>
        </v-card-text>

        <!-- Link -->
        <v-card-text class="d-flex align-center justify-center flex-wrap mt-2">
          <router-link :to="{ name:'login' }">
            Go to login page
          </router-link>
        </v-card-text>

        <!-- Flash Messages -->
        <FlashMessage :message="message" :error="error" />
      </v-card>
    </div>

    <!-- Background mask -->
    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
    >

    <!-- Decorative images -->
    <v-img
      class="auth-tree my-5"
      width="247"
      height="185"
      src="@/assets/images/misc/school.png"
    ></v-img>

    <v-img
      class="auth-tree-3"
      width="400"
      height="250"
      src="@/assets/images/misc/school-bus-side-view.png"
    ></v-img>
  </div>
</template>

<script>
import { getError } from "@/utils/helpers";
import AuthService from "@/services/AuthService";
import FlashMessage from "@/components/FlashMessage";
import { Keys } from "/src/config.js";

export default {
  name: "ResetPassword",
  components: {
    FlashMessage,
    Keys,
  },
  data() {
    return {
      password: null,
      passwordConfirm: null,
      error: null,
      message: null,
      systemName: Keys.VUE_APP_SYSTEM_NAME,
    };
  },
  methods: {
    resetPassword() {
      this.error = null;
      this.message = null;

      if (this.password !== this.passwordConfirm) {
        this.error = "Passwords do not match.";
        return;
      }

      const payload = {
        password: this.password,
        token: localStorage.getItem("reset_token"),
      };

      AuthService.resetPassword(payload)
        .then(() => {
          this.message = "Password reset successfully.";
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 1000);
        })
        .catch((error) => {
          this.error = getError(error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "~@/plugins/vuetify/default-preset/preset/pages/auth.scss";
</style>
